import React from "react";
import "./ContextMenus.css";

/**
 * HeaderContextMenu
 * Right-click menu on column / row headers — Hide / Unhide actions.
 *
 * Props:
 *   type        – "col" | "row"
 *   index       – index of the right-clicked header
 *   position    – { x, y } viewport coordinates
 *   hiddenSet   – Set of currently hidden indices for this axis
 *   onHide      – (index) => void
 *   onUnhide    – (indices[]) => void
 *   onClose     – () => void
 */
function HeaderContextMenu({ type, index, position, hiddenSet, onHide, onUnhide, onClose }) {
  const label = type === "col" ? "Column" : "Row";

  // Detect adjacent hidden runs so we can offer "Unhide" with the right set.
  const hiddenNeighbours = [];
  for (let i = Math.max(0, index - 1); i <= index + 1; i++) {
    if (hiddenSet.has(i)) hiddenNeighbours.push(i);
  }
  if (hiddenNeighbours.length > 0) {
    let lo = Math.min(...hiddenNeighbours);
    let hi = Math.max(...hiddenNeighbours);
    while (lo > 0 && hiddenSet.has(lo - 1)) lo--;
    while (hiddenSet.has(hi + 1)) hi++;
    for (let i = lo; i <= hi; i++) {
      if (hiddenSet.has(i) && !hiddenNeighbours.includes(i)) hiddenNeighbours.push(i);
    }
    hiddenNeighbours.sort((a, b) => a - b);
  }
  const canUnhide = hiddenNeighbours.length > 0;

  return (
    <>
      <div
        className="header-ctx-backdrop"
        onClick={onClose}
        onContextMenu={(e) => { e.preventDefault(); onClose(); }}
      />
      <div
        className="header-ctx-menu"
        style={{ left: position.x, top: position.y }}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="header-ctx-item" onClick={() => { onHide(index); onClose(); }}>
          <span className="material-icons header-ctx-icon">visibility_off</span>
          Hide {label}
        </button>
        {canUnhide && (
          <button type="button" className="header-ctx-item" onClick={() => { onUnhide(hiddenNeighbours); onClose(); }}>
            <span className="material-icons header-ctx-icon">visibility</span>
            Unhide {label}{hiddenNeighbours.length > 1 ? "s" : ""}
          </button>
        )}
      </div>
    </>
  );
}

export default HeaderContextMenu;
